  import { type Theme, useMediaQuery } from '@mui/material';

const useMobileScreen = () : boolean => useMediaQuery((theme : Theme) => theme.breakpoints.down('sm'), {noSsr: true});

export default useMobileScreen;